import { render, staticRenderFns } from "./AccountFormModal.vue?vue&type=template&id=5b97d2c4&scoped=true"
import script from "./AccountFormModal.vue?vue&type=script&lang=js"
export * from "./AccountFormModal.vue?vue&type=script&lang=js"
import style0 from "./AccountFormModal.vue?vue&type=style&index=0&id=5b97d2c4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b97d2c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b97d2c4')) {
      api.createRecord('5b97d2c4', component.options)
    } else {
      api.reload('5b97d2c4', component.options)
    }
    module.hot.accept("./AccountFormModal.vue?vue&type=template&id=5b97d2c4&scoped=true", function () {
      api.rerender('5b97d2c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settlement/bank-account/components/AccountFormModal.vue"
export default component.exports